export class Component {
    // Конструктор класса, принимает контейнер DOM-элемента, в котором будет размещаться компонент
    constructor(container) {
        this.container = container;
    }
    // Метод для переключения класса у элемента
    toggleClass(element, className, force) {
        element.classList.toggle(className, force);
    }
    // Метод для установки текстового содержимого элемента
    setText(element, value) {
        if (element) {
            element.textContent = String(value);
        }
    }
    // Метод для установки состояния блокировки элемента
    setDisabled(element, state) {
        if (element) {
            if (state)
                element.setAttribute('disabled', 'disabled');
            else
                element.removeAttribute('disabled');
        }
    }
    // Метод для скрытия элемента
    setHidden(element) {
        element.style.display = 'none';
    }
    // Метод для отображения элемента
    setVisible(element) {
        element.style.removeProperty('display');
    }
    // Метод для установки изображения с альтернативным текстом
    setImage(element, src, alt) {
        if (element) {
            element.src = src;
            if (alt) {
                element.alt = alt;
            }
        }
    }
    // Метод для рендеринга компонента
    // Принимает частичные данные (Partial<T>) и присваивает их текущему объекту,
    // затем возвращает контейнер DOM-элемента
    render(data) {
        Object.assign(this, data !== null && data !== void 0 ? data : {});
        return this.container;
    }
}
